<template>
<main-content>
    <kt-panel-body v-if="ip_location !== 'IR'">
        <div class="alert alert-danger" role="alert">
            {{ $t('label.ir_ip_error') }}
        </div>
    </kt-panel-body>
    <gateway-form v-else :form_data="form_data" :submit="submit" :wizard="wizard"></gateway-form>
</main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import GatewayForm from './components/form'
import $ from 'jquery'
import { gatewayService, authService } from '@/common/api.service'
import { mapGetters } from 'vuex'
import { userTypes } from '@/constants/userTypes'

export default {
    components: {
        'main-content': mainContent,
        'gateway-form': GatewayForm
    },
    data() {
        return {
            ip_location: '',
            user_types: userTypes,
            wizard: {
                current_step: 4,
                show: true,
                navigable: true,
                submit_in_progress: false,
            },
        }
    },
    computed: {
        form_data: {
            get: function() {
                return this.$store.state.gateway.form_data
            },
            set: function(value) {
                this.$store.commit('gateway/setFormData', value)
            }
        },
        ...mapGetters('user', [
            'current_user',
        ]),
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.$store.commit('gateway/clearFormData');
        })
    },
    mounted() {
        authService.get_ip().then(response => {
            this.ip_location = response.data.countryCode;
        });

        if (this.$store.getters["pardakhtShakhsi/status"] != 'success') {
            this.$store.dispatch("pardakhtShakhsi/fetch");
        }
    },
    methods: {
        submit(e) {
            this.wizard.submit_in_progress = true;
            let form = $('#gateway_form')
            let btn = $('#submit_btn')
            form.validate({
                rules: {
                    farsi_name: {
                        required: true,
                    },
                    english_name: {
                        required: true,
                    },
                    subcategory_code: {
                        required: true,
                    },
                    address: {
                        required: true,
                    },
                    telephone: {
                        required: true,
                    },
                    phone_number:{
                        required: true,
                        maxlength : 11,
                        minlength : 11,
                        number: true
                    },
                    logo: {
                        required: true,
                    },
                    sheba_number: {
                        required: true,
                    },
                    // wage: {
                    //     required: true,
                    // },
                    merchant_share_percent: {
                        required: true,
                    },
                    site_address: {
                        required: true,
                    },
                    // tax_payer_code: {
                    //     required: () => {
                    //         return this.current_user.user_type == this.user_types.LEGAL;
                    //     },
                    // },
                    // birth_crtfct_number: {
                    //     required: () => {
                    //         return this.current_user.user_type == this.user_types.REAL;
                    //     },
                    // },
                    // birth_crtfct_serial: {
                    //     required: () => {
                    //         return this.current_user.user_type == this.user_types.REAL;
                    //     },
                    // },
                    // birth_crtfct_series_letter: {
                    //     required: () => {
                    //         return this.current_user.user_type == this.user_types.REAL;
                    //     },
                    // },
                    // birth_crtfct_series_number: {
                    //     required: () => {
                    //         return this.current_user.user_type == this.user_types.REAL;
                    //     },
                    // },
                }
            })

            if(!form.valid()) {
                this.wizard.submit_in_progress = false;
                return;
            }

            let params = this.$store.getters['gateway/form_data']
            params = {...params,birth_crtfct_number:0}
            gatewayService.create(params).then(response => {
                this.$store.dispatch('gateway/gatewayTab', 6)
                this.$router.push('/gateways')
            })
            .catch(({response}) => {
                if(response.data) {
                    form.validate().showErrors(response.data.data)
                }
                this.showMsg(form, 'danger', response.data.message)
                for (let err in response.data.data) {
                    this.showMsg(form,'danger',response.data.data[err][0]);
                }
            })
            .finally(() => {
                this.wizard.submit_in_progress = false;
            })
        },
    },
}
</script>
